import React from 'react';
import './toggleSlider.scss';

interface ToggleSliderProps {
    name: string;
    checked: boolean;
    labelInfo?: { label: string; id: string; };
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ToggleSlider = React.memo(({name, checked, onChange, labelInfo}: ToggleSliderProps) => {
    return (
        <label className="toggle-slider">
            {labelInfo && <label htmlFor={labelInfo.id}>{labelInfo.label}</label>}
            <input id={labelInfo?.id} type="checkbox" checked={checked} name={name} onChange={onChange}/>
            <span className="slider round"/>
        </label>
    );
});
